import React, { useRef, useEffect } from "react";
import Icon from "./Icons";
import "../styles/SideNavBar.css";
import { gsap } from "gsap";

export default function SideNavBar() {
  const sideNavRef = useRef(null);
  const iconsRef = useRef([]);

  useEffect(() => {
    if (sideNavRef.current) {
      gsap.set(sideNavRef.current, {
        autoAlpha: 1,
        y: 0
      });

      gsap.set(iconsRef.current, {
        autoAlpha: 0,
        y: -20,
        x: -10
      });

      gsap.to(iconsRef.current, {
        autoAlpha: 1,
        y: 0,
        x: 0,
        duration: 0.5,
        stagger: 0.1,
        ease: "back.out(1.4)",
        delay: 0.9
      });
    }
  }, []);

  const addToRefs = (el) => {
    if (el && !iconsRef.current.includes(el)) {
      iconsRef.current.push(el);
    }
  };

  return (
    <div className="side-navbar" ref={sideNavRef}>
      <div className="mail-hint" aria-hidden="true" ref={addToRefs}>
        <span className="mail-hint-label">mail</span>
        <svg className="mail-hint-arrow" viewBox="0 0 24 60" fill="none">
          <path d="M12 2 C4 10, 20 18, 12 26 C4 34, 12 38, 12 44 L12 54" />
          <path d="M5 45 L12 55 L19 45" />
        </svg>
      </div>
      <a href="mailto:contact@faizaan.me" title="Email" target="_blank" rel="noopener noreferrer" ref={addToRefs}>
        <Icon name="Email" className="sidenav-icon" />
      </a>
      <a href="https://www.linkedin.com/in/faizaan-fareed-1a7b74221/" title="LinkedIn" target="_blank" rel="noopener noreferrer" ref={addToRefs}>
        <Icon name="Linkedin" className="sidenav-icon" />
      </a>
      <a href="https://youtube.com/@SAPToPowerBI" title="YouTube" target="_blank" rel="noopener noreferrer" ref={addToRefs}>
        <Icon name="YouTube" className="sidenav-icon" />
      </a>
    </div>
  );
}
